module.exports = __webpack_public_path__ + "static/Find Us Store 4-01-476260c9ab9000b6735ef8d2f6f1110c.png";